module.exports = __webpack_public_path__ + "static/media/cross.162463fc.svg";